export default __webpack_public_path__ + "static/media/blik-icon.95e62336.ico";